import { configureStore } from "@reduxjs/toolkit";
import { formbricksApi, lumiApi } from "./api";
import authReducer from "./slices/authSlice";
import fontManagerReducer from "./slices/fontManagerSlice";
import dashboardReducer from "./slices/dashboardSlice";
import projectReducer from "./slices/projectSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        fontManager: fontManagerReducer,
        dashboard: dashboardReducer,
        project: projectReducer,
        [lumiApi.reducerPath]: lumiApi.reducer,
        [formbricksApi.reducerPath]: formbricksApi.reducer,
    },
    devTools: true, // TODO: change this value based on env
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "lumiApi/executeMutation/fulfilled",
                    "formbricksApi/executeMutation/fulfilled",
                ],
                ignoredPaths: ["lumiApi.mutations", "formbricksApi.mutations"],
            },
        }).concat([lumiApi.middleware, formbricksApi.middleware]),
});

export default store;
